module.exports = {
  viewportSize: function() {
    var el = window.document.compatMode === 'CSS1Compat' ?
        window.document.documentElement :
        window.document.body;
    return [el.clientWidth, el.clientHeight];
  },
  screenSize: function() {
    return [window.screen.width, window.screen.height];
  },
  pixelRatio: function() {
    return window.devicePixelRatio || (window.screen.deviceXDPI / window.screen.logicalXDPI) || 1;
  }
};



//////////////////
// WEBPACK FOOTER
// ./lib/ui.js
// module id = 17
// module chunks = 1 3